<template>
    <div>
        <div class="app-title">
            <div>
                <h2>补充打印</h2>
            </div>
        </div>
        <section class="app-content">
            <el-form :inline="true" :model="entity" class="demo-form-inline">
                <table>
                    <tr>
                        <th>
                            <el-form-item label="项目号">
                                <el-input v-model="entity.projectCode"></el-input>
                            </el-form-item>
                        </th>
                        <th>
                            <el-form-item label="WBS">
                                <el-input v-model="entity.wbsNo"></el-input>
                            </el-form-item>
                        </th>
                        <th>
                            <el-form-item label="物料号">
                                <el-input v-model="entity.materielCode"></el-input>
                            </el-form-item>
                        </th>
                        <th>
                            <el-form-item label="物料描述">
                                <el-input
                                        type="textarea"
                                        autosize
                                        placeholder="请输入内容"
                                        v-model="entity.descriptionCh">
                                </el-input>
                            </el-form-item>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            <el-form-item label="MatDescription">
                                <el-input
                                        type="textarea"
                                        autosize
                                        placeholder="please input"
                                        v-model="entity.descriptionEn">
                                </el-input>
                            </el-form-item>
                        </th>
                        <th>
                            <el-form-item label="数量">
                                <el-input v-model="entity.purchaseQuantity"></el-input>
                            </el-form-item>
                        </th>
                        <th>
                            <el-form-item label="数量单位">
                                <el-input v-model="entity.materielUnit"></el-input>
                            </el-form-item>
                        </th>
                        <th>
                            <el-form-item label="PO">
                                <el-input v-model="entity.logPoId"></el-input>
                            </el-form-item>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            <el-form-item label="PO ITEM">
                                <el-input v-model="entity.poItem"></el-input>
                            </el-form-item>
                        </th>
                        <th>
                            <el-form-item label="生产订单号">
                                <el-input v-model="entity.productionNumber"></el-input>
                            </el-form-item>
                        </th>
                        <th>
                            <el-form-item label="生产订单Item">
                                <el-input v-model="entity.productionItem"></el-input>
                            </el-form-item>
                        </th>
                        <th>
                            <el-form-item label="发货码">
                                <el-input v-model="entity.deliverCode"></el-input>
                            </el-form-item>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            <el-form-item label="批次号">
                                <el-input v-model="entity.batchNumber"></el-input>
                            </el-form-item>
                        </th>
                        <th>
                            <el-form-item label="毛重">
                                <el-input v-model="entity.grossWeight"></el-input>
                            </el-form-item>
                        </th>
                        <th>
                            <el-form-item label="净重">
                                <el-input v-model="entity.netWeight"></el-input>
                            </el-form-item>
                        </th>
                        <th>
                            <el-form-item label="重量单位">
                                <el-input v-model="entity.weightUnit"></el-input>
                            </el-form-item>
                        </th>
                    </tr>
                    <tr>
                        <th style="vertical-align: top;text-align: center;">
                            <el-button @click="printCustomLabel">打印</el-button>
                        </th>
                    </tr>
                </table>
            </el-form>
        </section>
    </div>
</template>

<script>

    export default {
        name: 'sithMesInventoryAddPrint',

        data() {
            return {
                entity: {
                    'materielCode': '',
                    'descriptionCh': '',
                    'descriptionEn': '',
                    'purchaseQuantity': '',
                    'materielUnit': '',
                    'logPoId': '',
                    'poItem': '',
                    'deliverCode': '',
                    'batchNumber': '',
                    'productionNumber': '',
                    'productionItem': '',
                    'projectCode': '',
                    'wbsNo': '',
                    'grossWeight': '',
                    'netWeight': '',
                    'weightUnit': '',
                }
            }
        },
        components: {},
        computed: {},
        methods: {
            printCustomLabel() {
                let items = [];
                if(this.checkType(this.entity)){
                    items.push(this.entity);
                    this.$router.push({
                        name: 'sithMesInventoryItemPrint',
                        query: items
                    });
                }
            },
            checkType(item) {
                if(!this.isNumber(item.purchaseQuantity) || !this.isNumber(item.grossWeight) || !this.isNumber(item.netWeight) || !this.isInteger(item.logPoId)) {
                    this.$store.dispatch("base/showDanger", {
                        userAlertDangerStr: "输入有误！数量、重量需为数值,采购订单ID为整数",
                        userAlertDangerVisible: true,
                    }, {root: true});
                    return false;
                }
               return true;
            },
            //检查整数或者小数
            isNumber(value) {
                return /^\d*(\.\d+)?$/.test(value);
            },
            //检查整数
            isInteger(value){
                return /^\d*$/.test(value);
            }
        },

        created() {
        },
    };
</script>
<style>
    label {
        width: 120px;
    }

    textarea {
        min-height: 40px;
    }
</style>